import React, { useEffect } from 'react';
export default function Graph617(props) {
    let {a, b, c, d, e, f} = props.data;
        
    props.board.create('functiongraph',[function(x){return a*x + b;}],{strokeColor:'blue',highlightStrokeColor:'blue'});
    props.board.create('functiongraph',[function(x){return c*x + d;}],{strokeColor:'green',highlightStrokeColor:'green'});
    props.board.create('functiongraph',[function(x){return e*x + f;}],{strokeColor:'red',highlightStrokeColor:'red'});

    return <></>
}